import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    payedAmount: 'Al betaald',
    dueAmount: 'Openstaand bedrag',
  },
  en: {},
};
